// Suivi d'audience via Google Analytics (GA4).
// Les appels sont volontairement défensifs : si Google Analytics n'est pas
// encore connecté, aucune erreur n'est levée et aucun événement n'est envoyé.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

// Google Analytics est-il chargé et prêt ?
export function isAnalyticsReady(): boolean {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

// Envoie un événement personnalisé à GA4 (silencieux si GA absent).
export function trackEvent(eventName: string, params: Record<string, unknown> = {}): void {
  if (!isAnalyticsReady()) return;
  window.gtag?.('event', eventName, params);
}

// Vue de page : enregistre un page_view pour l'URL courante.
// Chaque URL SEO (ex. /rabat/agdal/cardiologue) est ainsi comptée comme une vue
// distincte, y compris lors des navigations sans rechargement (SPA).
export function trackPageView(path: string, title?: string): void {
  if (!isAnalyticsReady()) return;
  const pagePath = path || '/';
  window.gtag?.('event', 'page_view', {
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_title: title ?? document.title,
  });
}

export interface SearchTracking {
  city?: string;
  district?: string;
  specialty?: string;
  nameQuery?: string;
  resultsCount?: number;
}

// Événement de recherche : transmet les dimensions ville / quartier / spécialité
// pour savoir quelles combinaisons amènent le plus de trafic.
export function trackSearch({
  city,
  district,
  specialty,
  nameQuery,
  resultsCount,
}: SearchTracking): void {
  const locationParts = [specialty, district, city].filter(Boolean);
  const searchTerm = locationParts.length ? locationParts.join(' · ') : nameQuery || '';

  trackEvent('search', {
    search_term: searchTerm || 'recherche globale',
    city: city ?? '',
    district: district ?? '',
    specialty: specialty ?? '',
    name_query: nameQuery ?? '',
    results_count: resultsCount ?? undefined,
  });
}